import { render, staticRenderFns } from "./DaftarMenu.vue?vue&type=template&id=51f57699&scoped=true"
import script from "./DaftarMenu.vue?vue&type=script&lang=js"
export * from "./DaftarMenu.vue?vue&type=script&lang=js"
import style0 from "./DaftarMenu.vue?vue&type=style&index=0&id=51f57699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f57699",
  null
  
)

export default component.exports